import React from "react";
import ReactDOM from "react-dom/client";
import { ClerkProvider } from "@clerk/clerk-react";
import { library } from '@fortawesome/fontawesome-svg-core';
import { faSignOutAlt, faChartLine } from '@fortawesome/free-solid-svg-icons';
import App from "./App";
import "./index.css";

// Add Font Awesome icons to the library
library.add(faSignOutAlt, faChartLine);

const clerkPubKey = "pk_test_Z3Jvd2luZy1ncm91cGVyLTM2LmNsZXJrLmFjY291bnRzLmRldiQ";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <ClerkProvider publishableKey={clerkPubKey}>
    <App />
  </ClerkProvider>
);